import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ArrowsDownUpIcon, FunnelSimpleIcon, TruckIcon } from '@phosphor-icons/react'

import { Button, ButtonSelect } from '@reveni-io/reveni-ui'

import FiltersDrawer from '@/common/components/FiltersDrawer/FiltersDrawer'
import QueryFilter from '@/common/components/QueryFilter/QueryFilter'
import { showClearFiltersButton } from '@/common/components/SelectedFilters/helpers'
import SelectedFilters from '@/common/components/SelectedFilters/SelectedFilters'
import { parcelDirections } from '@/parcels/constants'

import { filterNames } from '../constants'
import {
  applyFilters,
  clearAllFilters,
  dateFilterConfig,
  dateFilterNames,
  filterFields,
  getDefaultFilterValue,
  getFilterLabel,
  getInitialFilters,
  isFilterValid,
} from './helpers'
import * as Styles from './styles'

const Filters = ({
  query,
  onChangeFilter,
  orderBy,
  onApplyFilters,
  filters,
  regions,
  carriers,
  carrierServices,
  locations,
  direction,
  filterTypes,
  sections,
  onOpenRequestPickupDrawer,
}) => {
  const { t } = useTranslation()
  const [showFiltersDrawer, setShowFiltersDrawer] = useState(false)

  const handleDeleteFilter = filterName => {
    if (dateFilterNames.includes(filterName)) {
      const config = dateFilterConfig[filterName]
      onChangeFilter(config.dateStart, null, false)
      onChangeFilter(config.dateEnd, null, false)
      onChangeFilter(config.daysGte, null, false)
      onChangeFilter(config.daysLte, null, true)
    } else if ([filterNames.shipmentsCarrier, filterNames.parcelType].includes(filterName)) {
      onChangeFilter(filterName, [], true)
    } else {
      onChangeFilter(filterName, null, true)
    }
  }

  const handleClearFilters = () => {
    clearAllFilters(onChangeFilter)
  }

  const handleOpenDrawer = () => {
    setShowFiltersDrawer(true)
  }

  const handleCloseDrawer = () => {
    setShowFiltersDrawer(false)
  }

  const handleApplyDrawer = activeFilters => {
    applyFilters(activeFilters, onChangeFilter)
    onApplyFilters()
  }

  const handleGetInitialFilters = currentFilters => getInitialFilters(currentFilters, filterTypes)

  const handleGetFilterLabel = filter => getFilterLabel(filter, filterTypes)

  const handleChangeQuery = query => onChangeFilter(filterNames.query, query)
  const handleChangeQueryValue = query => onChangeFilter(filterNames.query, query, false)
  const handleChangeOrderBy = value => onChangeFilter(filterNames.orderBy, value)

  const hasActiveFilters = showClearFiltersButton(filters)
  const fieldProps = { regions, carriers, carrierServices, locations, direction, t }
  const chipContext = { regions, carriers, carrierServices, locations }

  return (
    <>
      <Styles.Container>
        <Styles.HeaderContainer>
          <Styles.LeftFiltersContainer>
            <QueryFilter
              placeholder={t('Núm. de pedido, email o núm. de seguimiento')}
              defaultValue={query}
              onChange={handleChangeQuery}
              onChangeValue={handleChangeQueryValue}
              width="380px"
            />
            <ButtonSelect
              Icon={ArrowsDownUpIcon}
              value={orderBy}
              buttonSize="s"
              buttonVariant="text"
              handleChange={handleChangeOrderBy}
              menuItems={[
                { value: 'sku_count', label: t('Número de productos') },
                { value: '-created_at', label: t('Fecha de creación') },
                { value: '-shipped_at', label: t('Fecha de envío') },
              ]}
            />
            <Button variant="text" size="s" onClick={handleOpenDrawer}>
              <FunnelSimpleIcon size={24} weight="light" />
              {hasActiveFilters ? t('Editar filtros') : t('Añadir filtro')}
            </Button>
          </Styles.LeftFiltersContainer>
          {direction === parcelDirections.outbound && (
            <Button variant="outlined" onClick={onOpenRequestPickupDrawer}>
              <TruckIcon size={16} /> {t('Solicitar recogida')}
            </Button>
          )}
        </Styles.HeaderContainer>
        <SelectedFilters
          filters={filters}
          onDeleteFilter={handleDeleteFilter}
          onClickFilter={handleOpenDrawer}
          regions={regions}
          carriers={carriers}
          carrierServices={carrierServices}
          locations={locations}
        />
      </Styles.Container>
      <FiltersDrawer
        show={showFiltersDrawer}
        onClose={handleCloseDrawer}
        onApply={handleApplyDrawer}
        onClearFilters={handleClearFilters}
        appliedFilters={filters}
        filterTypes={filterTypes}
        sections={sections}
        getInitialFilters={handleGetInitialFilters}
        getDefaultFilterValue={getDefaultFilterValue}
        getFilterLabel={handleGetFilterLabel}
        isFilterValid={isFilterValid}
        filterFields={filterFields}
        fieldProps={fieldProps}
        chipContext={chipContext}
      />
    </>
  )
}

export default Filters
